var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceFactoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.2196 28.5697L17.2191 28.5694C16.5568 28.0747 16.1699 27.2939 16.1699 26.47V15H31.8399V26.47C31.8399 27.2939 31.453 28.0747 30.7907 28.5694L30.7903 28.5697L25.5805 32.4696C24.648 33.1668 23.3618 33.1668 22.4293 32.4696L17.2196 28.5697Z",
    fill: "#6F00FF",
    stroke: "#6F00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14.75H14C13.8661 14.75 13.75 14.6339 13.75 14.5C13.75 14.3661 13.8661 14.25 14 14.25H34C34.1339 14.25 34.25 14.3661 34.25 14.5C34.25 14.6339 34.1339 14.75 34 14.75Z",
    fill: "#6F00FF",
    stroke: "#6F00FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.25H20C19.8661 20.25 19.75 20.1339 19.75 20C19.75 19.8661 19.8661 19.75 20 19.75H28C28.1339 19.75 28.25 19.8661 28.25 20C28.25 20.1339 28.1339 20.25 28 20.25Z",
    fill: "#6F00FF",
    stroke: "#6F00FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25.75H20C19.59 25.75 19.25 25.41 19.25 25C19.25 24.59 19.59 24.25 20 24.25H28C28.41 24.25 28.75 24.59 28.75 25C28.75 25.41 28.41 25.75 28 25.75Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceFactoring);
export default __webpack_public_path__ + "static/media/InvoiceFactoring.912d1ffdfcd527bfaf99c544b6b2371d.svg";
export { ForwardRef as ReactComponent };